import Link from 'next/link';
import styled from 'styled-components';

const BREAKPOINT = 'max-width: 650px';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px auto;
`;

export const Content = styled.nav`
  display: flex;
  flex-direction: row;
  border-top: 1px solid ${(props) => props.theme.keyline};
  border-left: 1px solid ${(props) => props.theme.keyline};
  border-bottom: 1px solid ${(props) => props.theme.keyline};

  @media (${BREAKPOINT}) {
    display: none;
  }
`;

export const MobileWrapper = styled.nav<{ hasPrev: boolean; hasNext: boolean }>`
  display: none;

  @media (${BREAKPOINT}) {
    display: flex;
    flex-direction: row;
    width: 260px;
    justify-content: ${({ hasPrev, hasNext }) => (hasPrev && hasNext ? 'space-between' : 'center')};
  }
`;

export const Item = styled(Link)<{ $active?: boolean; $noHover?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-right: 1px solid ${(props) => props.theme.keyline};
  font-size: 16px;

  ${(props) =>
    props.$active
      ? `
    color: ${props.theme.primary};
    background: ${props.theme.background};
    font-weight: bold;
  `
      : `
    color: ${props.theme.textDark};
    background: ${props.theme.backgroundLightest};
    font-weight: normal;
  `}

  &:hover {
    background-color: ${({ theme, $noHover }) => ($noHover ? 'none' : theme.backgroundLighter)};
  }

  @media (${BREAKPOINT}) {
    width: auto;
    min-width: 120px;
    border: 1px solid ${({ theme }) => theme.keyline};
    background: ${({ theme }) => theme.backgroundLighter};
    font-weight: normal;
    color: ${({ theme }) => theme.textDark};
  }
`;
